import React from "react";

/* COMPONENTS */
import { IFRAME_DIGITALSIGN_URL } from "../../config";
import { useSelector } from "react-redux";
import "./studio.css";
import { FormattedMessage } from "react-intl";
import ImgNoService from "../../assets/img/sign-noService.svg";
import { Button } from "@ts-digital/vrc";
import { TSDIGITAL_PORTALE_PUBLIC_URL } from "../../config.js";
import Page from "../../components/general/page";
import { useIntl } from "react-intl";
import DbxChildAppView from "../childApp";

const SignatureStudio = ({ pageRef }) => {
  const company = useSelector((state) => state.company);
  const servicesAgyo = useSelector((state) => state.servicesAgyo);
  const main = useSelector((state) => state.main);
  const user = useSelector((state) => state.user);
  const companySelected = main.companySelected;
  const clientIdSelected = main.clientIdSelected;
  const myType = main.myType;

  const intl = useIntl();

  const link = TSDIGITAL_PORTALE_PUBLIC_URL + "#/" + clientIdSelected + "/apps/firma/details";

  if (!companySelected) return null;
  let ragioneSociale =
    company &&
    company.companies.find((el) => {
      return el.codiceFiscale === companySelected;
    }).ragioneSociale;
  const element =
    servicesAgyo &&
    servicesAgyo.allAccountantServices &&
    servicesAgyo.allAccountantServices.status.ended &&
    servicesAgyo.allAccountantServices.status.list &&
    servicesAgyo.allAccountantServices.status.list.find((el) => {
      return el.id === "SIGNATURE-FLOW";
    });

  const noService = (element && !element.active) || !element || !servicesAgyo || (servicesAgyo && !servicesAgyo.allAccountantServices) || myType !== "STUDIO";

  return (
    <div>
      {noService ? (
        <Page
          pageRef={pageRef}
          className={"contentStructure transparent"}
          style={{
            overflow: "hidden",
            position: "relative",
            height: "100%",
            marginTop: "64px",
            zIndex: 1
          }}
          title={"DIGITAL SIGNATURE"}
          subtitle={ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + companySelected}
          servicesAgyo={servicesAgyo}
        >
          <div className="containerListSign" id="noServiceDiv">
            <div className="textEmptyService">
              <FormattedMessage id="signature.noService" />{" "}
              <div className="subTitleSign">
                <FormattedMessage id="signature.subtitle1" /> <b>Ts Digital Signature</b>
                <FormattedMessage id="signature.subtitle2" />{" "}
              </div>
              <div className="subTitleSign">
                <FormattedMessage id="signature.subtitle3" />{" "}
              </div>
              <div className="subTitleSign">
                <FormattedMessage id="signature.subtitle4" />{" "}
              </div>
            </div>

            <div
              style={{
                flex: "2",
                background: `url(${ImgNoService})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundColor: "white",
                backgroundPosition: "center bottom",
                display: "flex",
                justifyContent: "center"
              }}
            >
              <a href={link} target="_blank" rel="noopener noreferrer">
                <Button style={{ width: "212px", marginTop: "30px" }}>
                  <FormattedMessage id="dashboard.showMore" />
                </Button>
              </a>
            </div>
          </div>
        </Page>
      ) : (
        <DbxChildAppView customLaunchData={{ oldUserId: user && user.profile.id }} url={IFRAME_DIGITALSIGN_URL} />
      )}
    </div>
  );
};

export default SignatureStudio;
